module.exports = __webpack_public_path__ + "static/img/subheader-contact.428f4ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/subheader-contact.jpg
// module id = 6cJO
// module chunks = 1